module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ts-progress"
  }, [_c('div', {
    staticClass: "ts-progress-bar"
  }, [_c('div', {
    staticClass: "ts-progress-bar-outer",
    style: ({
      height: _vm.strokeWidth + 'px'
    })
  }, [_c('div', {
    staticClass: "ts-progress-bar-inner",
    style: (_vm.barStyle)
  }, [_c('div', {
    staticClass: "ts-progress-bar-innerText"
  }, [_vm._v(_vm._s(_vm.percentage) + "%")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4e46d479"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/tsProgress.vue
// module id = 829
// module chunks = 39